import { useAccessibility } from '../../context/AccessibilityContext/AccessibilityContext'

import style from './button.module.scss'

const Button = ({type = 'button', width, height, padding, fontSize, fontFamily, fontWeight, onClick, color, text, border, borderRadius, background, className}) => {
    const { settings } = useAccessibility();

    const getColors = () => {
        if (settings.contrast === 'dark') {
            return {
                bg: '#000',
                text: '#fff',
                border: '1px solid #fff'
            };
        }
        if (settings.contrast === 'light') {
            return {
                bg: '#fff',
                text: '#000',
                border: '1px solid #000'
            };
        }
        return {
            bg: background || 'var(--button-bg, #1d3e8c)',
            text: color || 'var(--button-text, #fff)',
            border: border || 'var(--button-border, none)'
        };
    }

  const colors = getColors()
    
    const config = {
        width:          width || 'fit-content',
        height:         height || 'fit-content',
        padding:        padding || '2vh 2vw',
        background:     colors.bg,
        border:         colors.border,
        borderRadius:   borderRadius || '0',
    }

    const textConfig = {
        color:      colors.text,
        fontSize:   fontSize || '1rem',
        fontFamily: fontFamily || 'Roboto, sans-serif',
        fontWeight: fontWeight || '400',
    }

    const handleOnClick = (e) => {
        e.preventDefault()
        onClick()
    }

    return (
        <button
            className={`${style.button} ${className}`}
            style={config}
            onClick={onClick}
            type={type}
            aria-label={text}
        >
            <span
                className={style.text}
                style={textConfig}
            >
                {text}
            </span>
        </button>
    )
}

export default Button